import axios from 'axios'
export default () => {
  const axiosConf = axios.create({
    baseURL : "https://api.brevo.com/v3/",
    headers: {
      'Accept': 'application/json',
      'Access-Control-Allow-Origin': '*'
    }
  })
  
  axiosConf.defaults.headers['API-key'] = process.env.VUE_APP_BREVO_API_KEY
  axiosConf.defaults.headers.post['Content-Type'] = 'Application/json'
  return axiosConf
}